<template>
    <div class="goods-list">
        <div class="goods-list-title">选择商品类型</div>
        <div class="goods-list-content">
            <template v-for="item in goodsList">
                <div
                    v-if="canBuyList.includes(item.canbuy)"
                    :key="item.goodsId"
                    class="goods-list-card"
                    :class="{
                        'goods-list-card-active': selectId === item.goodsId,
                        'goods-list-card-disabled': !canBuyList.includes(
                            item.canbuy
                        ),
                    }"
                    @click="selectGoods(item)"
                >
                    <div
                        class="goods-list-card-img"
                        :style="{backgroundImage: `url(${item.icon})`}"
                    ></div>
                    <div class="goods-list-card-name">{{ item.name }}</div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
/**
 * @file index.vue
 * @desc 线索购买
 * @author sunxiaofeng01
 */
import icon from '../static/icon-clue.png';
import member from '../static/member.png';
import vka from '../../../assets/img/law/vka.png';
import lawFirmIcon from '../static/law-firm-icon.png';
import exportsIcon from '../static/export.png';
import additionalClue from '../static/additional-clue.png';
import youngIcon from '../static/young.png';
export default {
    name: 'goodsList',
    props: {
        canBuyList: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            selectId: '',
            goodsList: [
                {
                    name: '至尊会员',
                    goodsId: '7',
                    icon: lawFirmIcon,
                    comp: 'goodsFormMember',
                    canbuy: 'business_vip'
                },
                {
                    name: '尊享会员',
                    goodsId: '3',
                    icon: member,
                    comp: 'goodsFormMember',
                    canbuy: 'full_vip'
                },
                {
                    name: '精英会员',
                    goodsId: '2001',
                    icon: 'https://lvlin-base.cdn.bcebos.com/fe-saas/page/goods-purchase/elite-member-icon.png',
                    comp: 'goodsFormMember',
                    canbuy: 'elite_vip'
                },
                {
                    name: '启航会员',
                    goodsId: '2000',
                    icon: youngIcon,
                    comp: 'goodsFormYoung',
                    canbuy: 'young_vip'
                },
                {
                    name: 'C位律师',
                    goodsId: '8',
                    icon: exportsIcon,
                    comp: 'goodsFormExposure',
                    canbuy: 'cpt_vip'
                },
                {
                    name: '线索加购',
                    goodsId: '1000',
                    icon: additionalClue,
                    comp: 'goodsFormAddClue',
                    canbuy: 'clue_quota'
                },
                {
                    name: '线索包',
                    goodsId: '5',
                    icon: icon,
                    comp: 'goodsForm',
                    canbuy: 'clue'
                },
                {
                    name: '律临V卡',
                    goodsId: '6',
                    icon: vka,
                    comp: 'goodsFormLight',
                    canbuy: 'vcard_vip'
                }
            ]
        };
    },
    methods: {
        selectGoods(item) {
            if (this.canBuyList.includes(item.canbuy)) {
                this.$emit('setGoodsFn', 'goodsList', item);
                this.selectId = item.goodsId;
            }
        }
    }
};
</script>

<style lang="stylus" scoped >
.goods-list {
    &-title {
        height: 28px;
        line-height: 28px;
        font-family: PingFangSC-Semibold;
        font-size: 20px;
        color: #000;
        font-weight: 600;
    }

    &-card {
        width: 140px;
        height: 100px;
        background: #fff;
        border: 1px solid #e2e6f0;
        border-radius: 6px;
        display: inline-flex;
        align-items: center;
        flex-direction: column;
        margin-top: 16px;
        margin-right: 24px;
        cursor: pointer;

        &-img {
            width: 50px;
            height: 50px;
            background: url("../static/icon-clue.png") center center no-repeat;
            margin: 9px 0 5px;
            background-size: 100% auto;
        }

        &-name {
            font-size: 14px;
            color: #282c33;
        }
    }

    .goods-list-card-active {
        background: #f0f6ff;
        border-color: #0052cc;
    }

    .goods-list-card-disabled {
        background: #e2e6f0;
        border-color: transparent;
    }
}
</style>
